import script from "./CourseView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseView.vue?vue&type=script&setup=true&lang=ts"

import "./CourseView.vue?vue&type=style&index=0&id=6d09d116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d09d116"]])

export default __exports__